module.exports = __webpack_public_path__ + "static/media/Skall.e70ceb3a.mp3";